import React, { useContext, memo } from "react";
import {
  InfoWindow
} from "@react-google-maps/api";
import { WebMapContext } from "../WebMapGoogleMap";
import { geohashMiddle } from "../../../../constants/WebMap";
import CapacityTooltip from "../../../../components/elements/CapacityTooltip";


const CapacityTooltipSection = ({
  eyeIcons,
  tooltipData,
  setTooltipData,
  geohashZoom
}) => {
  const {
    mapZoomLevel
  } = useContext(WebMapContext);

  return (
    tooltipData
      ? (eyeIcons.capacity && mapZoomLevel >= geohashZoom) 
        ? <InfoWindow
          position={{
            lat: tooltipData.polygon[3].lat,
            lng: tooltipData.polygon[3].lng + geohashMiddle[tooltipData.geohash?.length || 7],
          }}
          onCloseClick={() => {
            setTooltipData(null);
          }}
          options={{ disableAutoPan: true }}
        >
          {eyeIcons.capacity ? (
            <CapacityTooltip
            headerData={tooltipData.header}
            bodyData={tooltipData.body}
            geohash={tooltipData.geohash}
            />
          ): (
            <></>
          )}
        </InfoWindow>
        : <></>
      : <></>
  )
};

export default memo(CapacityTooltipSection);